const questions = [
  {
    question: "Für welche Klassen gibst du Nachhilfe?",
    answer: "Ich biete persönliche Online-Mathenachhilfe von Klasse 6 bis zum Abitur an – von Grundlagen über Mittelstufe bis zur Oberstufe und Abiturvorbereitung.",
  },
  {
    question: "Wie läuft die kostenlose Probestunde ab?",
    answer: "Wir lernen uns 45 Minuten kennen, schauen auf deinen aktuellen Stand und bearbeiten gemeinsam eine passende Aufgabe. Danach entscheidest du ohne Druck, ob du weitermachen möchtest.",
  },
  {
    question: "Wie findet der Unterricht statt?",
    answer: "Die Nachhilfe findet online per Google Meet statt. Am digitalen Whiteboard können wir Rechenwege gemeinsam entwickeln und nachvollziehen.",
  },
  {
    question: "Welche Technik brauche ich?",
    answer: "Du brauchst eine stabile Internetverbindung, einen Computer oder ein Tablet sowie Mikrofon und möglichst eine Kamera. Ein moderner Browser reicht aus.",
  },
  {
    question: "Wie flexibel sind die Termine?",
    answer: "Freie Zeiten siehst du direkt im Kalender. Alternativ finden wir per WhatsApp gemeinsam einen passenden Termin.",
  },
  {
    question: "Was kostet die Nachhilfe nach der Probestunde?",
    answer: "Die Preise richten sich nach der Klassenstufe: Klasse 6–7 kosten 20 €, Klasse 8–10 kosten 25 € und Klasse 11 bis zum Abitur kosten 30 € pro 60 Minuten. Die erste Probestunde mit 45 Minuten ist kostenlos. Der Preis richtet sich nach deiner Klassenstufe zu Beginn der Nachhilfe. Wenn du während einer laufenden Zusammenarbeit in eine höhere Klassenstufe wechselst, bleibt dein Einstiegspreis als Treuebonus bestehen, solange du regelmäßig Nachhilfe bei mir nimmst.",
  },
];

export function FaqSection() {
  return (
    <section className="faq-section section-pad" id="faq" aria-labelledby="faq-title">
      <div className="section-heading centered">
        <div className="eyebrow">Häufige Fragen</div>
        <h2 id="faq-title">Das Wichtigste vorab.</h2>
      </div>
      <div className="faq-list">
        {questions.map(({ question, answer }) => (
          <details key={question}>
            <summary>{question}</summary>
            <p>{answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
